import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import { Getdonedealreportadvancedaction } from '../Redux/Actions/UsersAction';
import { GetAllcomments_Data_With_Pagination_action_advanced } from '../Redux/Actions/Action_action';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import {
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Pagination,
  Button,
  Chip,
  Stack,
  Typography,
  Box,
  alpha,
  useTheme,
  LinearProgress as MuiLinearProgress,
  IconButton,
} from '@mui/material';
import { Comment, Close } from '@mui/icons-material';
import moment from 'moment';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

/* ─── tiny icons ──────────────────────────────────────────────────────────── */
const IconRefresh   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>;
const IconDownload  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>;
const IconSearch    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconUsers     = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IconTrophy    = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2z"/></svg>;
const IconMoney     = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>;
const IconChart     = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;
const IconChevL     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>;
const IconChevR     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>;
const IconComment   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
const IconClose     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;

/* ─── Constants ──────────────────────────────────────────────────────────── */
const ENGLISH_MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
const MONTHS_SHORT   = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

const formatDateToEnglish = (arabicDate) => {
  if (!arabicDate) return 'N/A';
  let converted = arabicDate;
  const arabicDigits = '٠١٢٣٤٥٦٧٨٩';
  for (let i = 0; i < arabicDigits.length; i++) converted = converted.split(arabicDigits[i]).join(String(i));
  converted = converted.replace(/[\u0000-\u001F\u007F-\u009F\u2000-\u200F\u2028-\u202F]/g, '');
  converted = converted.replace(/[\/\\\.,،]/g, '/');
  const parts = converted.split('/').map(p => parseInt(p.trim())).filter(p => !isNaN(p));
  if (parts.length >= 3) {
    let [day, month, year] = parts;
    if (year < 100) year += 2000;
    if (month > 12 && day <= 12) { [day, month] = [month, day]; }
    if (month >= 1 && month <= 12 && day >= 1 && day <= 31) return `${ENGLISH_MONTHS[month - 1]} ${day}, ${year}`;
  }
  return arabicDate;
};

const getInitials = (name) => {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};

const getStageColor = (stageName) => {
  const s = stageName?.toLowerCase();
  if (s === 'done deal') return '#059669';
  if (s === 'hot') return '#ef4444';
  if (s === 'warm') return '#f59e0b';
  if (s === 'cold') return '#0D47A1';
  if (s === 'eoi') return '#f97316';
  if (s === 'reservation') return '#8b5cf6';
  return '#6b7280';
};

/* ─── Comments Dialog ────────────────────────────────────────────────────── */
const CommentsDialog = ({ open, onClose, leadId, leadName }) => {
  const dispatch = useDispatch();
  const [comments, setComments]   = useState([]);
  const [loading, setLoading]     = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages]   = useState(1);
  const userlogin = JSON.parse(localStorage.getItem('user'))?.data || {};

  const fetchComments = useCallback(async (page = 1) => {
    if (!leadId || !userlogin?._id) return;
    setLoading(true);
    try {
      const res = await dispatch(GetAllcomments_Data_With_Pagination_action_advanced({ leadId, userId: userlogin._id, page, limit: 5 }));
      if (res?.success && res?.comments) {
        setComments(res.comments);
        setCurrentPage(res.pagination?.page || page);
        setTotalPages(res.pagination?.totalPages || 1);
      }
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [dispatch, leadId, userlogin?._id]);

  useEffect(() => { if (open && leadId) fetchComments(1); }, [open, leadId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3, fontFamily: "'Plus Jakarta Sans', sans-serif" } }}>
      <div style={{ background: '#0D47A1', padding: '18px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ color: '#fff', fontWeight: 700, fontSize: 16, fontFamily: "'Plus Jakarta Sans', sans-serif", display: 'flex', alignItems: 'center', gap: 10 }}>
          <IconComment /> Comments — {leadName}
        </div>
        <button onClick={onClose} style={{ background: 'rgba(255,255,255,.15)', border: 'none', borderRadius: 8, width: 32, height: 32, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
          <IconClose />
        </button>
      </div>
      <div style={{ padding: 24, maxHeight: '60vh', overflowY: 'auto' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40 }}><CircularProgress size={28} /></div>
        ) : comments.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>
            <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>No comments found</p>
          </div>
        ) : comments.map((comment, i) => (
          <div key={comment._id || i} style={{ background: '#f9fafb', borderRadius: 12, padding: 16, marginBottom: 12, border: '1px solid #f0f0f0' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
              <div style={{ width: 38, height: 38, borderRadius: 10, background: '#0D47A1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 13 }}>
                {getInitials(comment.sales?.name)}
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 13, color: '#111827', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{comment.sales?.name}</div>
                <div style={{ fontSize: 11, color: '#9ca3af', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  {comment.sales?.role} · {moment(comment.stageDate).format('DD/MM/YYYY hh:mm A')}
                </div>
              </div>
              {comment.stage && (
                <div style={{ marginLeft: 'auto', background: getStageColor(comment.stage.name), color: '#fff', borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 700, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  {comment.stage.name}
                </div>
              )}
            </div>
            {comment.firstcomment?.text && (
              <div style={{ marginBottom: 8 }}>
                <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600, marginBottom: 4, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>FIRST COMMENT</div>
                <div style={{ fontSize: 13, color: '#374151', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{comment.firstcomment.text}</div>
              </div>
            )}
            {comment.secondcomment?.text && (
              <div>
                <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600, marginBottom: 4, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>SECOND COMMENT</div>
                <div style={{ fontSize: 13, color: '#374151', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{comment.secondcomment.text}</div>
              </div>
            )}
          </div>
        ))}
      </div>
      {totalPages > 1 && (
        <div style={{ padding: '12px 24px', borderTop: '1px solid #f0f0f0', display: 'flex', justifyContent: 'center' }}>
          <Pagination count={totalPages} page={currentPage} onChange={(e, p) => fetchComments(p)} color="primary" size="small" />
        </div>
      )}
    </Dialog>
  );
};

/* ─── Main Component ─────────────────────────────────────────────────────── */
export const DoneDealReportPage = () => {
  const dispatch     = useDispatch();
  const theme        = useTheme();
  const sidebarWidth = useSidebarWidth();

  const [selectedSales, setSelectedSales] = useState('');
  const [selectedYear,  setSelectedYear]  = useState(new Date().getFullYear());
  const [loading,       setLoading]       = useState(false);
  const [page,          setPage]          = useState(1);
  const [limit,         setLimit]         = useState(10);
  const [searchQuery,   setSearchQuery]   = useState('');
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [commentsDialog, setCommentsDialog] = useState({ open: false, leadId: null, leadName: '' });

  useEffect(() => { dispatch(Get_All_Sales_Action()); }, [dispatch]);

  const ressales   = useSelector(s => s.AllSales.sales);
  const reportData = useSelector(s => s.Allusers.Get_users);

  const yearsArray = useMemo(() => {
    const cur = new Date().getFullYear();
    return Array.from({ length: cur - 2019 }, (_, i) => cur - i);
  }, []);

  const salesarray = useMemo(() => (
    (Array.isArray(ressales?.data) ? ressales.data : [])
      .filter(s => !['Default','Default M','Default T','Default S','Developer','Dev'].includes(s?.name))
      .sort((a, b) => {
        if (a?.name === 'No Sales') return -1;
        if (b?.name === 'No Sales') return 1;
        return a?.name?.localeCompare(b?.name);
      })
  ), [ressales]);

  const fetchReport = useCallback(async (pageNumber = page, pageLimit = limit) => {
    if (!selectedSales) return;
    setLoading(true);
    try { await dispatch(Getdonedealreportadvancedaction(selectedSales, pageNumber, pageLimit, selectedYear)); }
    finally { setLoading(false); }
  }, [dispatch, selectedSales, selectedYear, page, limit]);

  useEffect(() => { if (selectedSales) { setPage(1); fetchReport(1, limit); } }, [selectedSales, selectedYear]);

  const handlePageChange = (e, newPage) => { setPage(newPage); fetchReport(newPage, limit); };
  const handleLimitChange = (e) => {
    const n = parseInt(e.target.value, 10); setLimit(n); setPage(1); fetchReport(1, n);
  };

  const filteredLeads = useMemo(() => {
    if (!reportData?.leads?.data) return [];
    let leads = [...reportData.leads.data];
    if (selectedMonth !== null && selectedMonth !== 'all') {
      leads = leads.filter(lead => {
        if (!lead.doneDealDate) return false;
        const arabicDigits = '٠١٢٣٤٥٦٧٨٩';
        let converted = lead.doneDealDate;
        for (let i = 0; i < arabicDigits.length; i++) converted = converted.split(arabicDigits[i]).join(String(i));
        converted = converted.replace(/[\/\\\.,،]/g, '/');
        const parts = converted.split('/').map(p => parseInt(p.trim())).filter(p => !isNaN(p));
        if (parts.length >= 2) return parseInt(parts[1], 10) === selectedMonth + 1;
        return false;
      });
    }
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      leads = leads.filter(l =>
        (l.name?.toLowerCase() || '').includes(q) ||
        (l.project?.toLowerCase() || '').includes(q) ||
        (l.phone?.toLowerCase() || '').includes(q) ||
        (l.unitNumber?.toLowerCase() || '').includes(q)
      );
    }
    return leads;
  }, [reportData?.leads?.data, selectedMonth, searchQuery]);

  const monthlyData     = reportData?.monthlyData || [];
  const pagination      = reportData?.leads?.pagination;
  const totalDeals      = reportData?.statistics?.totalYearDeals || 0;
  const currentMonthDeals = reportData?.statistics?.currentMonthDeals || 0;
  const totalCommission = reportData?.statistics?.financial?.totalCommission || 0;
  const avgCommission   = reportData?.statistics?.financial?.avgCommissionPerDeal || 0;
  const maxDealsInMonth = useMemo(() => Math.max(...monthlyData.map(m => m.count), 1), [monthlyData]);

  const selectedSalesInfo = salesarray.find(s => s._id === selectedSales) || null;

  const chartData = useMemo(() => {
    if (!reportData?.monthlyData) return null;
    return {
      labels: MONTHS_SHORT,
      datasets: [{
        label: 'Deals',
        data: reportData.monthlyData.map(m => m.count),
        borderColor: '#0D47A1',
        backgroundColor: 'rgba(13,71,161,0.08)',
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#0D47A1',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 8,
        borderWidth: 2.5,
      }],
    };
  }, [reportData]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: (evt, elements) => { if (elements.length > 0) setSelectedMonth(elements[0].index); },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: '#fff',
        titleColor: '#111827',
        bodyColor: '#6b7280',
        borderColor: '#e5e7eb',
        borderWidth: 1,
        padding: 10,
        titleFont: { family: "'Plus Jakarta Sans', sans-serif", size: 13, weight: '700' },
        bodyFont: { family: "'Plus Jakarta Sans', sans-serif", size: 12 },
        callbacks: { label: ctx => `${ctx.parsed.y} deal${ctx.parsed.y !== 1 ? 's' : ''}` },
      },
    },
    scales: {
      x: { grid: { display: false }, ticks: { font: { size: 11, family: "'Plus Jakarta Sans', sans-serif" }, color: '#9ca3af' } },
      y: {
        beginAtZero: true,
        grid: { color: '#f3f4f6' },
        ticks: { font: { size: 11, family: "'Plus Jakarta Sans', sans-serif" }, color: '#9ca3af', precision: 0 },
      },
    },
  };

  /* ─── render ─── */
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .dd-root { font-family: 'Plus Jakarta Sans', sans-serif; }

        /* stat cards */
        .dd-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-bottom: 24px; }
        .dd-stat-card {
          background: #fff; border-radius: 14px; padding: 22px 24px;
          border: 1px solid #f0f0f0; box-shadow: 0 2px 12px rgba(0,0,0,0.04);
          position: relative; overflow: hidden;
        }
        .dd-stat-label { font-size: 11px; font-weight: 700; letter-spacing: .07em; text-transform: uppercase; color: #9ca3af; margin-bottom: 6px; }
        .dd-stat-val   { font-size: 32px; font-weight: 800; color: #111827; line-height: 1.1; }
        .dd-stat-badge {
          display: inline-flex; align-items: center; gap: 4px; margin-top: 8px;
          font-size: 11px; font-weight: 600; padding: 3px 9px; border-radius: 20px;
        }
        .dd-stat-badge.green { background: #dcfce7; color: #16a34a; }
        .dd-stat-badge.blue  { background: #eff6ff; color: #0D47A1; }
        .dd-stat-badge.amber { background: #fef3c7; color: #d97706; }
        .dd-stat-icon {
          position: absolute; top: 18px; right: 20px; width: 40px; height: 40px;
          border-radius: 10px; display: flex; align-items: center; justify-content: center;
        }
        .dd-stat-icon.blue  { background: #eff6ff; color: #0D47A1; }
        .dd-stat-icon.green { background: #f0fdf4; color: #16a34a; }
        .dd-stat-icon.amber { background: #fef3c7; color: #d97706; }
        .dd-stat-trend { font-size: 12px; color: #6b7280; margin-top: 4px; }

        /* filter bar */
        .dd-filter-bar {
          background: #fff; border-radius: 14px; padding: 20px 24px;
          border: 1px solid #f0f0f0; box-shadow: 0 2px 12px rgba(0,0,0,0.04);
          margin-bottom: 24px;
        }
        .dd-filter-row { display: grid; grid-template-columns: 2fr 1fr auto; gap: 14px; align-items: end; }
        .dd-filter-label { font-size: 11px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; color: #9ca3af; margin-bottom: 6px; display: block; }
        .dd-input {
          width: 100%; padding: 9px 12px; border-radius: 8px; font-size: 13px;
          border: 1.5px solid #e5e7eb; background: #f9fafb; color: #111827;
          font-family: 'Plus Jakarta Sans', sans-serif; outline: none; box-sizing: border-box;
          transition: border-color .2s;
        }
        .dd-input:focus { border-color: #0D47A1; background: #fff; }
        .dd-select {
          width: 100%; padding: 9px 12px; border-radius: 8px; font-size: 13px;
          border: 1.5px solid #e5e7eb; background: #f9fafb; color: #111827;
          font-family: 'Plus Jakarta Sans', sans-serif; outline: none; cursor: pointer;
          transition: border-color .2s;
        }
        .dd-select:focus { border-color: #0D47A1; }
        .dd-btn {
          padding: 9px 18px; border-radius: 8px; font-size: 13px; font-weight: 600;
          cursor: pointer; border: none; display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif; transition: all .18s; white-space: nowrap;
        }
        .dd-btn-primary { background: #0D47A1; color: #fff; }
        .dd-btn-primary:hover { background: #0a3d8f; }
        .dd-btn-ghost { background: #f1f5f9; color: #374151; }
        .dd-btn-ghost:hover { background: #e2e8f0; }
        .dd-btn:disabled { opacity: .5; cursor: not-allowed; }

        /* year quick chips */
        .dd-year-chips { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 14px; }
        .dd-ychip {
          padding: 5px 13px; border-radius: 20px; font-size: 12px; font-weight: 600;
          cursor: pointer; border: 1.5px solid #e5e7eb; background: #fff; color: #6b7280;
          transition: all .15s;
        }
        .dd-ychip:hover, .dd-ychip.active { border-color: #0D47A1; background: #eff6ff; color: #0D47A1; }

        /* month filter chips */
        .dd-month-chips { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 14px; }
        .dd-mchip {
          padding: 5px 12px; border-radius: 8px; font-size: 12px; font-weight: 600;
          cursor: pointer; border: 1.5px solid #e5e7eb; background: #fff; color: #6b7280;
          transition: all .15s; white-space: nowrap;
        }
        .dd-mchip:hover { border-color: #0D47A1; background: #eff6ff; color: #0D47A1; }
        .dd-mchip.active { border-color: #0D47A1; background: #0D47A1; color: #fff; }

        /* sales banner */
        .dd-sales-banner {
          display: flex; align-items: center; justify-content: space-between;
          padding: 14px 18px; border-radius: 10px;
          background: linear-gradient(135deg, #0D47A1 0%, #1565C0 100%);
          margin-top: 16px; color: #fff;
        }

        /* main grid */
        .dd-main-grid { display: grid; grid-template-columns: 360px 1fr; gap: 20px; margin-bottom: 24px; }

        /* chart card */
        .dd-chart-card {
          background: #fff; border-radius: 14px; padding: 22px 24px;
          border: 1px solid #f0f0f0; box-shadow: 0 2px 12px rgba(0,0,0,0.04);
          display: flex; flex-direction: column;
        }
        .dd-card-title { font-size: 14px; font-weight: 700; color: #111827; margin-bottom: 4px; }
        .dd-card-sub   { font-size: 12px; color: #9ca3af; margin-bottom: 16px; }

        /* monthly breakdown card */
        .dd-monthly-card {
          background: #fff; border-radius: 14px; padding: 22px 24px;
          border: 1px solid #f0f0f0; box-shadow: 0 2px 12px rgba(0,0,0,0.04);
          overflow: hidden;
        }
        .dd-month-row {
          display: flex; align-items: center; justify-content: space-between;
          padding: 10px 12px; border-radius: 10px; cursor: pointer;
          border: 1.5px solid #f0f0f0; margin-bottom: 8px;
          transition: all .15s; background: #fff;
        }
        .dd-month-row:hover { border-color: #0D47A1; background: #f8fbff; }
        .dd-month-row.active { border-color: #0D47A1; background: #eff6ff; }

        /* highest deal card */
        .dd-deal-card {
          background: #fff; border-radius: 14px; padding: 22px 24px;
          border: 1px solid #f0f0f0; border-left: 4px solid #f59e0b;
          box-shadow: 0 2px 12px rgba(0,0,0,0.04); margin-bottom: 24px;
        }
        .dd-deal-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 12px; margin-top: 16px; }
        .dd-deal-item { background: #f9fafb; border-radius: 10px; padding: 12px 14px; border: 1px solid #f0f0f0; }
        .dd-deal-item-label { font-size: 11px; color: #9ca3af; font-weight: 600; margin-bottom: 4px; text-transform: uppercase; letter-spacing: .06em; }
        .dd-deal-item-val   { font-size: 14px; font-weight: 700; color: #111827; }
        .dd-deal-item-val.green { color: #059669; }
        .dd-deal-item-val.amber { color: #d97706; }

        /* table card */
        .dd-table-card {
          background: #fff; border-radius: 14px; overflow: hidden;
          border: 1px solid #f0f0f0; box-shadow: 0 2px 12px rgba(0,0,0,0.04);
          margin-bottom: 24px;
        }
        .dd-table-header { padding: 20px 24px 16px; border-bottom: 1px solid #f3f4f6; }
        .dd-search-wrap { position: relative; }
        .dd-search-wrap svg { position: absolute; left: 11px; top: 50%; transform: translateY(-50%); color: #9ca3af; pointer-events: none; }
        .dd-search-input {
          padding: 8px 12px 8px 34px; border-radius: 8px; font-size: 13px;
          border: 1.5px solid #e5e7eb; background: #f9fafb; color: #111827;
          font-family: 'Plus Jakarta Sans', sans-serif; outline: none; width: 240px; box-sizing: border-box;
        }
        .dd-search-input:focus { border-color: #0D47A1; background: #fff; }

        /* table */
        .dd-table { width: 100%; border-collapse: collapse; }
        .dd-table thead th {
          padding: 11px 14px; font-size: 11px; font-weight: 700; letter-spacing: .06em;
          text-transform: uppercase; color: #6b7280; background: #f9fafb;
          border-bottom: 1px solid #f0f0f0; text-align: left; white-space: nowrap;
        }
        .dd-table tbody tr { border-bottom: 1px solid #f9fafb; transition: background .12s; }
        .dd-table tbody tr:hover { background: #f9fafb; }
        .dd-table tbody td { padding: 12px 14px; font-size: 13px; color: #374151; vertical-align: middle; }
        .dd-lead-name { font-weight: 600; color: #111827; font-size: 13px; }
        .dd-badge {
          display: inline-flex; padding: 3px 10px; border-radius: 20px;
          font-size: 11px; font-weight: 700; color: #fff;
        }
        .dd-unit-badge {
          display: inline-flex; padding: 3px 10px; border-radius: 6px;
          font-size: 11px; font-weight: 600; background: #f3f4f6; color: #374151;
          border: 1px solid #e5e7eb;
        }
        .dd-action-btn {
          width: 30px; height: 30px; border-radius: 8px; border: 1.5px solid #e5e7eb;
          background: #fff; cursor: pointer; display: inline-flex; align-items: center;
          justify-content: center; color: #6b7280; transition: all .15s;
        }
        .dd-action-btn:hover { border-color: #0D47A1; color: #0D47A1; background: #eff6ff; }

        /* pagination */
        .dd-pagination {
          padding: 14px 20px; border-top: 1px solid #f3f4f6;
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 10px;
        }
        .dd-pag-info { font-size: 12px; color: #6b7280; }
        .dd-pag-btns { display: flex; gap: 4px; align-items: center; }
        .dd-pag-btn {
          width: 32px; height: 32px; border-radius: 8px; border: 1.5px solid #e5e7eb;
          background: #fff; cursor: pointer; display: flex; align-items: center;
          justify-content: center; font-size: 13px; font-weight: 600; color: #374151;
          transition: all .15s; font-family: 'Plus Jakarta Sans', sans-serif;
        }
        .dd-pag-btn:hover   { border-color: #0D47A1; color: #0D47A1; background: #eff6ff; }
        .dd-pag-btn.active  { background: #0D47A1; border-color: #0D47A1; color: #fff; }
        .dd-pag-btn:disabled{ opacity: .4; cursor: not-allowed; }

        /* progress bar */
        .dd-progress-track { height: 6px; background: #f0f0f0; border-radius: 3px; overflow: hidden; margin-top: 6px; }
        .dd-progress-fill  { height: 100%; background: #0D47A1; border-radius: 3px; transition: width .4s ease; }

        /* empty / loading */
        .dd-empty { text-align: center; padding: 50px 20px; color: #9ca3af; }
        .dd-empty p { font-size: 14px; margin-top: 8px; }

        @keyframes dd-progress { 0%{margin-left:-40%} 100%{margin-left:140%} }

        @media (max-width: 1100px) {
          .dd-main-grid { grid-template-columns: 1fr; }
        }
        @media (max-width: 900px) {
          .dd-stats { grid-template-columns: 1fr 1fr; }
          .dd-filter-row { grid-template-columns: 1fr 1fr; }
        }
        @media (max-width: 600px) {
          .dd-stats { grid-template-columns: 1fr; }
          .dd-filter-row { grid-template-columns: 1fr; }
        }
      `}</style>

      <div
        className="dd-root"
        style={{
          position: 'fixed',
          top: '50px',
          left: sidebarWidth,
          right: 0,
          bottom: 0,
          transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
          overflowY: 'auto',
          overflowX: 'hidden',
          backgroundColor: '#f4f6fb',
        }}
      >
        <div style={{ padding: '28px 28px 40px' }}>

          {/* ── Page Header ── */}
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
            <div>
              <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#111827' }}>Done Deal Report</h1>
              <p style={{ margin: '4px 0 0', fontSize: 13, color: '#9ca3af' }}>Comprehensive deal performance tracking and commission analytics.</p>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button className="dd-btn dd-btn-ghost" onClick={() => fetchReport(page, limit)} disabled={loading}>
                <IconRefresh /> Refresh
              </button>
            </div>
          </div>

          {/* ── Filter Bar ── */}
          <div className="dd-filter-bar">
            <div className="dd-filter-row">
              {/* Sales Person */}
              <div>
                <span className="dd-filter-label">Sales Person</span>
                <select className="dd-select" value={selectedSales} onChange={e => setSelectedSales(e.target.value)}>
                  <option value="">Select a sales executive…</option>
                  {salesarray.map(s => (
                    <option key={s._id} value={s._id}>{s.name || s._id}</option>
                  ))}
                </select>
              </div>

              {/* Year */}
              <div>
                <span className="dd-filter-label">Year</span>
                <select className="dd-select" value={selectedYear} onChange={e => setSelectedYear(Number(e.target.value))}>
                  {yearsArray.map(y => <option key={y} value={y}>{y}</option>)}
                </select>
              </div>

              {/* Generate */}
              <div>
                <span className="dd-filter-label">&nbsp;</span>
                <button className="dd-btn dd-btn-primary" onClick={() => { setPage(1); fetchReport(1, limit); }} disabled={!selectedSales || loading}>
                  <IconChart /> Generate Report
                </button>
              </div>
            </div>

            {/* Year quick chips */}
            <div className="dd-year-chips">
              <span style={{ fontSize: 12, color: '#9ca3af', fontWeight: 600 }}>Quick:</span>
              {yearsArray.slice(0, 4).map(y => (
                <span key={y} className={`dd-ychip ${selectedYear === y ? 'active' : ''}`} onClick={() => setSelectedYear(y)}>{y}</span>
              ))}
            </div>

            {/* Sales banner */}
            {selectedSalesInfo && (
              <div className="dd-sales-banner">
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14 }}>
                    {getInitials(selectedSalesInfo.name)}
                  </div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 14 }}>{selectedSalesInfo.name}</div>
                    <div style={{ fontSize: 12, opacity: .75 }}>
                      {selectedSalesInfo.email && selectedSalesInfo.email}
                      {selectedSalesInfo.phone && ` · ${selectedSalesInfo.phone}`}
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: 13, color: 'rgba(255,255,255,.8)', fontWeight: 600 }}>
                  {selectedYear} · {totalDeals} deals
                </div>
              </div>
            )}
          </div>

          {/* loading bar */}
          {loading && (
            <div style={{ marginBottom: 16 }}>
              <div style={{ height: 3, background: '#e5e7eb', borderRadius: 2, overflow: 'hidden' }}>
                <div style={{ height: '100%', background: '#0D47A1', borderRadius: 2, animation: 'dd-progress 1.4s ease-in-out infinite', width: '40%' }} />
              </div>
              <p style={{ textAlign: 'center', fontSize: 12, color: '#6b7280', marginTop: 8 }}>Loading data…</p>
            </div>
          )}

          {/* ── DATA SECTION ── */}
          {reportData?.success && !loading && (
            <>
              {/* ── STAT CARDS ── */}
              <div className="dd-stats">
                <div className="dd-stat-card">
                  <div className="dd-stat-label">Total Deals</div>
                  <div className="dd-stat-val">{totalDeals.toLocaleString()}</div>
                  <div><span className="dd-stat-badge green">↑ {currentMonthDeals} this month</span></div>
                  <div className="dd-stat-trend" style={{ marginTop: 6 }}>Year {selectedYear}</div>
                  <div className="dd-stat-icon blue"><IconChart /></div>
                </div>

                <div className="dd-stat-card">
                  <div className="dd-stat-label">Total Commission</div>
                  <div className="dd-stat-val" style={{ fontSize: 24 }}>{new Intl.NumberFormat('en-US').format(totalCommission)}</div>
                  <div><span className="dd-stat-badge amber">AED</span></div>
                  <div className="dd-stat-trend" style={{ marginTop: 6 }}>Accumulated earnings</div>
                  <div className="dd-stat-icon amber"><IconMoney /></div>
                </div>

                <div className="dd-stat-card">
                  <div className="dd-stat-label">Top Deal Value</div>
                  <div className="dd-stat-val" style={{ fontSize: 24, color: '#d97706' }}>
                    {new Intl.NumberFormat('en-US').format(reportData.highestDeal?.commission || 0)}
                  </div>
                  <div><span className="dd-stat-badge amber">AED Commission</span></div>
                  <div className="dd-stat-trend" style={{ marginTop: 6 }}>{reportData.highestDeal?.clientName || '—'}</div>
                  <div className="dd-stat-icon green"><IconTrophy /></div>
                </div>
              </div>

              {/* ── HIGHEST DEAL CARD ── */}
              {reportData.highestDeal && (
                <div className="dd-deal-card">
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                    <span style={{ fontSize: 18 }}>🏆</span>
                    <div className="dd-card-title">Highest Value Deal of {selectedYear}</div>
                  </div>
                  <div className="dd-card-sub">Best performing deal in the selected year</div>
                  <div className="dd-deal-grid">
                    {[
                      { label: 'Client Name',  val: reportData.highestDeal.clientName, cls: '' },
                      { label: 'Project',      val: reportData.highestDeal.project,    cls: '' },
                      { label: 'Unit Number',  val: reportData.highestDeal.unitNumber, cls: '' },
                      { label: 'Unit Price',   val: `${new Intl.NumberFormat('en-US').format(reportData.highestDeal.unitPrice)} AED`, cls: 'green' },
                      { label: 'Commission',   val: `${new Intl.NumberFormat('en-US').format(reportData.highestDeal.commission)} AED`, cls: 'amber' },
                      { label: 'Deal Date',    val: formatDateToEnglish(reportData.highestDeal.dealDate), cls: '' },
                    ].map((item, i) => (
                      <div key={i} className="dd-deal-item">
                        <div className="dd-deal-item-label">{item.label}</div>
                        <div className={`dd-deal-item-val ${item.cls}`}>{item.val || '—'}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* ── MAIN GRID: Chart + Monthly ── */}
              <div className="dd-main-grid">

                {/* Chart */}
                <div className="dd-chart-card">
                  <div className="dd-card-title">📈 Monthly Deals Trend</div>
                  <div className="dd-card-sub">Click a point to filter by month</div>
                  <div style={{ flex: 1, minHeight: 280, position: 'relative' }}>
                    {chartData && <Line data={chartData} options={chartOptions} />}
                  </div>

                  {/* Month filter chips */}
                  <div style={{ marginTop: 16 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#9ca3af', letterSpacing: '.06em', textTransform: 'uppercase', marginBottom: 8 }}>Filter by month</div>
                    <div className="dd-month-chips">
                      <span className={`dd-mchip ${selectedMonth === null ? 'active' : ''}`} onClick={() => setSelectedMonth(null)}>All</span>
                      {MONTHS_SHORT.map((m, i) => (
                        <span key={i} className={`dd-mchip ${selectedMonth === i ? 'active' : ''}`} onClick={() => setSelectedMonth(selectedMonth === i ? null : i)}>
                          {m} {monthlyData[i]?.count > 0 && <span style={{ opacity: .7 }}>({monthlyData[i].count})</span>}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Monthly Breakdown */}
                <div className="dd-monthly-card">
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                    <div className="dd-card-title">📅 Monthly Breakdown</div>
                    <div style={{ display: 'inline-flex', padding: '3px 10px', borderRadius: 20, background: '#eff6ff', color: '#0D47A1', fontSize: 12, fontWeight: 700 }}>
                      {totalDeals} total
                    </div>
                  </div>
                  <div style={{ maxHeight: 420, overflowY: 'auto', paddingRight: 4 }}>
                    {monthlyData.map((month, i) => (
                      <div
                        key={month.number || i}
                        className={`dd-month-row ${selectedMonth === i ? 'active' : ''}`}
                        onClick={() => setSelectedMonth(selectedMonth === i ? null : i)}
                      >
                        <div>
                          <div style={{ fontSize: 13, fontWeight: 700, color: '#111827' }}>{ENGLISH_MONTHS[i]}</div>
                          {month.commission > 0 && (
                            <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>
                              {new Intl.NumberFormat('en-US').format(month.commission)} AED
                            </div>
                          )}
                          <div className="dd-progress-track" style={{ width: 120 }}>
                            <div className="dd-progress-fill" style={{ width: `${(month.count / maxDealsInMonth) * 100}%` }} />
                          </div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{
                            display: 'inline-flex', padding: '3px 10px', borderRadius: 20,
                            background: month.count > 0 ? '#eff6ff' : '#f3f4f6',
                            color: month.count > 0 ? '#0D47A1' : '#9ca3af',
                            fontSize: 12, fontWeight: 700
                          }}>
                            {month.count} deal{month.count !== 1 ? 's' : ''}
                          </div>
                          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>
                            {((month.count / maxDealsInMonth) * 100).toFixed(0)}%
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Peak performance */}
                  {monthlyData.length > 0 && (
                    <div style={{ marginTop: 14, background: '#f9fafb', borderRadius: 10, padding: '10px 14px', border: '1px solid #f0f0f0' }}>
                      <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600, marginBottom: 2, textTransform: 'uppercase', letterSpacing: '.06em' }}>Peak Performance</div>
                      <div style={{ fontSize: 13, color: '#111827', fontWeight: 700 }}>
                        {ENGLISH_MONTHS[monthlyData.findIndex(m => m.count === Math.max(...monthlyData.map(m => m.count)))]}
                        {' '}— {Math.max(...monthlyData.map(m => m.count))} deals
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* ── DEALS TABLE ── */}
              <div className="dd-table-card">
                <div className="dd-table-header">
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
                    <div>
                      <div className="dd-card-title">
                        📋 Deals Details
                        {selectedMonth !== null && <span style={{ color: '#9ca3af', fontWeight: 500, marginLeft: 8, fontSize: 13 }}>— {ENGLISH_MONTHS[selectedMonth]}</span>}
                      </div>
                      <div className="dd-card-sub">
                        {reportData.salesInfo?.name} · {filteredLeads.length} deals shown
                        {pagination && ` · Page ${pagination.currentPage} of ${pagination.totalPages}`}
                      </div>
                    </div>
                    <div className="dd-search-wrap">
                      <IconSearch />
                      <input
                        className="dd-search-input"
                        placeholder="Search name, project, phone…"
                        value={searchQuery}
                        onChange={e => setSearchQuery(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div style={{ overflowX: 'auto' }}>
                  <table className="dd-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Client</th>
                        <th>Phone</th>
                        <th>Project</th>
                        <th>Unit</th>
                        <th>Unit Price</th>
                        <th>Commission</th>
                        <th>Deal Date</th>
                        <th>Stage</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredLeads.length === 0 ? (
                        <tr><td colSpan={10}><div className="dd-empty"><p>No deals found</p></div></td></tr>
                      ) : (
                        filteredLeads.map((lead, idx) => {
                          const num = (pagination ? (pagination.currentPage - 1) * pagination.itemsPerPage : 0) + idx + 1;
                          return (
                            <tr key={lead.id || idx}>
                              <td style={{ color: '#9ca3af', fontSize: 12 }}>{num}</td>
                              <td>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                  <div style={{ width: 34, height: 34, borderRadius: 9, background: '#0D47A1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 12, flexShrink: 0 }}>
                                    {getInitials(lead.name)}
                                  </div>
                                  <div className="dd-lead-name">{lead.name || '—'}</div>
                                </div>
                              </td>
                              <td style={{ fontSize: 12, color: '#6b7280' }}>{lead.phone || '—'}</td>
                              <td style={{ fontSize: 13, color: '#374151' }}>{lead.project || '—'}</td>
                              <td><span className="dd-unit-badge">{lead.unitNumber || '—'}</span></td>
                              <td style={{ fontSize: 13, fontWeight: 600, color: '#111827' }}>
                                {new Intl.NumberFormat('en-US').format(lead.unitPrice)} <span style={{ fontSize: 11, color: '#9ca3af' }}>AED</span>
                              </td>
                              <td>
                                <span style={{ display: 'inline-flex', padding: '3px 10px', borderRadius: 20, background: '#dcfce7', color: '#15803d', fontSize: 12, fontWeight: 700 }}>
                                  {new Intl.NumberFormat('en-US').format(lead.commissionMoney)} AED
                                </span>
                              </td>
                              <td style={{ fontSize: 12, color: '#6b7280' }}>{formatDateToEnglish(lead.doneDealDate)}</td>
                              <td>
                                <span className="dd-badge" style={{ background: getStageColor(lead.stage) }}>
                                  {lead.stage || '—'}
                                </span>
                              </td>
                              <td>
                                <button className="dd-action-btn" title="View Comments" onClick={() => setCommentsDialog({ open: true, leadId: lead.id, leadName: lead.name })}>
                                  <IconComment />
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {pagination && (
                  <div className="dd-pagination">
                    <div className="dd-pag-info">
                      <span>Items per page: </span>
                      <select className="dd-select" style={{ display: 'inline-block', width: 64, padding: '4px 8px', marginLeft: 6 }}
                        value={limit} onChange={handleLimitChange}>
                        {[5, 10, 25, 50].map(n => <option key={n} value={n}>{n}</option>)}
                      </select>
                      <span style={{ marginLeft: 12 }}>
                        Showing <strong>{(pagination.currentPage - 1) * pagination.itemsPerPage + 1}–{Math.min(pagination.currentPage * pagination.itemsPerPage, pagination.totalItems)}</strong>
                        {' '}of <strong>{pagination.totalItems}</strong> deals
                      </span>
                    </div>
                    <div className="dd-pag-btns">
                      <button className="dd-pag-btn" onClick={() => handlePageChange(null, 1)} disabled={pagination.currentPage === 1}>⟨|</button>
                      <button className="dd-pag-btn" onClick={() => handlePageChange(null, pagination.currentPage - 1)} disabled={pagination.currentPage === 1}><IconChevL /></button>
                      {Array.from({ length: Math.min(pagination.totalPages, 5) }, (_, i) => {
                        const total = pagination.totalPages;
                        const cur = pagination.currentPage;
                        let p;
                        if (total <= 5) p = i + 1;
                        else if (cur < 3) p = i + 1;
                        else if (cur > total - 3) p = total - 4 + i;
                        else p = cur - 2 + i;
                        return (
                          <button key={p} className={`dd-pag-btn ${pagination.currentPage === p ? 'active' : ''}`} onClick={() => handlePageChange(null, p)}>{p}</button>
                        );
                      })}
                      <button className="dd-pag-btn" onClick={() => handlePageChange(null, pagination.currentPage + 1)} disabled={pagination.currentPage >= pagination.totalPages}><IconChevR /></button>
                      <button className="dd-pag-btn" onClick={() => handlePageChange(null, pagination.totalPages)} disabled={pagination.currentPage >= pagination.totalPages}>|⟩</button>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}

          {/* No data */}
          {reportData && !reportData.success && selectedSales && !loading && (
            <div style={{ background: '#fff', borderRadius: 14, padding: 60, textAlign: 'center', border: '1px solid #f0f0f0' }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>📊</div>
              <p style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>No Data Available</p>
              <p style={{ color: '#9ca3af', fontSize: 13 }}>No completed deals found for {selectedYear}. Try a different year.</p>
              <button className="dd-btn dd-btn-primary" style={{ marginTop: 20 }} onClick={() => fetchReport(1, limit)}>
                <IconRefresh /> Try Again
              </button>
            </div>
          )}

          {/* Empty state */}
          {!selectedSales && (
            <div style={{ background: '#fff', borderRadius: 14, padding: 60, textAlign: 'center', border: '1.5px dashed #e5e7eb' }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>👆</div>
              <p style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>Select a Sales Person</p>
              <p style={{ color: '#9ca3af', fontSize: 13 }}>Choose a sales executive from the dropdown to generate the done deal report</p>
            </div>
          )}

        </div>
      </div>

      {/* Comments Dialog */}
      <CommentsDialog
        open={commentsDialog.open}
        onClose={() => setCommentsDialog({ open: false, leadId: null, leadName: '' })}
        leadId={commentsDialog.leadId}
        leadName={commentsDialog.leadName}
      />
    </>
  );
};